import React from "react";
import styled from "styled-components";

const OverlayInvalidMessage = (props) => {
  const handleClick = () => {
    props.overlayMessageToggle();
  };

  return (
    <OverlayBlock>
      <MessageBlock>
        <Message>{props.message}</Message>

        <div className="action-elem" onClick={() => handleClick()}>OK</div>
      </MessageBlock>
    </OverlayBlock>
  );
};

const OverlayBlock = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  background: rgba(0, 0, 0, 0.2);
  z-index: 101;
`;

const MessageBlock = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 80%;
  transform: translate(-50%, -50%);
  padding: 32px;
  box-sizing: border-box;
  border-radius: 8px;
  background: #ffffff;
`;

const Message = styled.div`
  text-align: center;
  padding-bottom: 12px;
`;

const ActionButton = styled.div`
  width: 100%;
  max-width: 200px;
  margin: 10px auto;
  background: #003e8d;
  border-radius: 4px;
  color: #fff;
  text-align: center;
  line-height: 36px;
  cursor: pointer;
  background: red;
`;

export default OverlayInvalidMessage;
